module.exports = __webpack_public_path__ + "static/media/Capacity.9d9e7b3d.svg";